import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  import { controls } from "../../controls";
  
  
  const pigmydeposit = {
    label: "Recurring Deposite",
    pageLabel: "Recurring Deposite",
    starting: true,
    url: "pigmydeposit",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form:[
   
      ...controls.displayText({label:"As On Date/Opening Date",width:"col-sm-4",star:true}),
          {
            inputType: "showdata",
            displaytype:'date',
            data: "as_on_date",
            textcolor: "black",
            name: "as_on_date",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
          },
      
      ...controls.displayText({width:"col-sm-4"}),
      ...controls.displayText({label:"Installment Amount",width:"col-sm-4",star:true}),
     
      {
        inputType: "numberonly",
        // tab: "pigmydeposit",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Installment Amount",
        name: "installment_amount",
        description: "Enter Installment Amount"
      },
      ...controls.displayText({tab:"pigmydeposit",width:"col-sm-4"}),
      ...controls.displayText({tab:"pigmydeposit",label:"Number Of Installment",width:"col-sm-4",star:true}),

      {
        inputType: "numberonly",
        tab: "pigmydeposit",
        isRequired:true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Number Of Installments",
        name: "number_of_installment",
        description: "Enter Number Of Installment"
      },
      
      ...controls.displayText({tab:"pigmydeposit",width:"col-sm-4"}),
      ...controls.displayText({tab:"pigmydeposit",label:"Maturity Date",width:"col-sm-4",star:true}),

      {
        inputType: "date",
        tab: "pigmydeposit",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Maturity Date",     
        name: "maturity_date",
        description: "Enter Maturity Date"
      },
      ...controls.displayText({tab:"pigmydeposit",width:"col-sm-4"}),
      ...controls.displayText({tab:"pigmydeposit",label:"Interest Rate",width:"col-sm-4"}),
      {
        inputType: "numberonly",
        tab: "pigmydeposit",
        // isReadOnly: true,
        defaultValue:10,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Interest Rate",
        name: "ints_rate",
        description: "Enter Interest Rate"
      },
      ...controls.displayText({tab:"pigmydeposit",width:"col-sm-4"}),
      ...controls.displayText({tab:"pigmydeposit",label:"Maturity Amount",width:"col-sm-4"}),
      {
        inputType: "text",
        tab: "pigmydeposit",
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Maturity Amount",
        name: "maturity_amount",
        description: "Enter Maturity Amount"
      },
      ...controls.displayText({tab:"pigmydeposit",width:"col-sm-4"}),
      ...controls.displayText({tab:"pigmydeposit",label:"Pigmy Agent",width:"col-sm-4"}),
      {
        inputType: "text",
        tab: "pigmydeposit",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Pigmy Agent",
        name: "PigmyAgent",
        description: "Enter Pigmy Agent"
      },
    ]
  }

  export default pigmydeposit;